// Decides whether a page load on the partner host (affiliate.truwe.in) should
// be bounced to the affiliate sign-in page.
//
// The affiliate host serves ONLY partner surfaces. Anything else — storefront,
// blog, admin — redirects to /affiliate/login. The host is also fully
// disallowed in robots.txt (see src/routes/robots[.]txt.ts), so nothing here
// is indexable.

export const AFFILIATE_HOST_PREFIX = "affiliate.";
export const AFFILIATE_ALLOWED_PREFIXES = [
  "/affiliate",
  "/auth",
  "/api",
  "/policies/affiliate-terms",
  "/policies/privacy",
  "/policies/terms",
];
export const AFFILIATE_LANDING_PATH = "/affiliate/login";

export function isAffiliateHost(host: string) {
  return host.toLowerCase().startsWith(AFFILIATE_HOST_PREFIX);
}

export function isAffiliateAllowedPath(path: string) {
  return AFFILIATE_ALLOWED_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));
}

/** True when this load on the partner host must be sent to the sign-in page. */
export function shouldRedirectToAffiliate(input: { host: string; path: string }) {
  if (!isAffiliateHost(input.host)) return false;
  return !isAffiliateAllowedPath(input.path);
}
